<template>
  <skeleton-card :height="height">
    <div class="d-flex align-items-center">
      <skeleton-icon :size="iconSize" :circle="circleIcon" class="me-3" />
      <div class="flex-grow-1">
        <skeleton-text variant="title" :width="titleWidth" />
        <skeleton-text variant="number" :width="numberWidth" />
      </div>
    </div>
  </skeleton-card>
</template>

<script>
import SkeletonCard from './SkeletonCard.vue';
import SkeletonIcon from './SkeletonIcon.vue';
import SkeletonText from './SkeletonText.vue';

export default {
  name: 'SkeletonWidget',
  components: {
    SkeletonCard,
    SkeletonIcon,
    SkeletonText
  },
  props: {
    height: {
      type: String,
      default: 'auto'
    },
    iconSize: {
      type: String,
      default: '42px'
    },
    circleIcon: {
      type: Boolean,
      default: false
    },
    titleWidth: {
      type: String,
      default: '70%'
    },
    numberWidth: {
      type: String,
      default: '50%'
    }
  }
}
</script>

<style scoped>
.me-3 {
  margin-right: 15px;
}

.flex-grow-1 {
  flex: 1;
}
</style>
